import { User } from '../types';
import api from './api';

// To-do: Define types for login/register credentials

export const login = async (credentials: any): Promise<User> => {
  const response = await api.post('/auth/login', credentials);
  return response.data.user;
};

export const register = async (credentials: any): Promise<User> => {
  const response = await api.post('/auth/register', credentials);
  return response.data.user;
};

export const logout = async (): Promise<any> => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const refresh = async (): Promise<User> => {
  const response = await api.post('/auth/refresh');
  return response.data.user;
};
